import * as React from 'react'

export const SwitcherTables = () => {
  return <div>Common page for 4 tables with switches</div>
}
